import { useState } from "react";
import { useRouter } from "next/router";
import style from "./FaqComponentNew.module.scss";
import { HandySvg } from "handy-svg";
import getCommonLocales from "../../locales/locales_common";
import getFaqLocales from "../../locales/locales_faq";

const dataForGenerators = (dictionary) => {
	return {
		PhotoIntoPainting: [
			{
				id: 1,
				question: "How to turn a picture into a painting?",
				answer: dictionary["In case you want to get a stunning art you just need to upload your image and AI will do the magic"],
			},
			{
				id: 3,
				question: "How to get the best result?",
				answer: dictionary["our converter works better with landscapes"],
			},
			{
				id: 4,
				question: "Photos of which formats can I upload?",
				answer: dictionary["We support photos of image formats"],
			},
			{
				id: 5,
				question: "Can I save the painting I created?",
				answer: dictionary["faq"]["Yes, any user can download and save it"],
			},
			{
				id: 6,
				question: "What tariffs users can use this service?",
				answer: dictionary["faq"]["The service is available for users of all tariffs"],
			},
			{
				id: 7,
				question: "Where the created images can be used?",
				answer: dictionary["Your artworks will look great as the illustrations or as posts on your social media"],
			},
			{
				id: 8,
				question: "Why the result didn’t meet my expectations?",
				answer: dictionary["ai we utilize may generate inaccuracies"],
			},
		],
		TextToImg: [
			{
				id: 1,
				question: "How to get the best result?",
				answer: dictionary["faq"]["Enter a description of what you want to see"],
			},
			{
				id: 2,
				question: "In what language can I enter a query?",
				answer: dictionary["use languages"],
			},
			{
				id: 3,
				question: " How does AI generate images?",
				answer: dictionary["faq"]["ai model is trained on a huge array of image-text"],
			},
			{
				id: 5,
				question: "What styles may I use?",
				answer: dictionary["faq"]["you can use from our templates"],
			},
			{
				id: 6,
				question: "What tariffs users can use this service?",
				answer: dictionary["faq"]["The service is available for users of all tariffs"],
			},
			{
				id: 7,
				question: "Can I save the image I have created?",
				answer: dictionary["page_generator"]["faq"]["answer_save"],
			},
			{
				id: 8,
				question: "Why do I have to wait for an image to be created?",
				answer: dictionary["faq"]["When you submit your query"],
			},
			{
				id: 9,
				question: "Where can the created images and artworks be used?",
				answer: dictionary["faq"]["You can find good examples of using AI"],
			},
			{
				id: 10,
				question: dictionary["page_image_generator"]["faq"]["question_10"],
				answer: dictionary["page_image_generator"]["faq"]["answer_10"],
				active: false,
				anchor: "negative",
				images: [
					{ id: 1, text: "prompt_mystery_forest", src: "/faq/ml_faq/negative1.jpg" },
					{ id: 2, text: "prompt_negative_prompt", src: "/faq/ml_faq/negative2.jpg" },
					{ id: 3, text: "prompt_boy_on_the_moon", src: "/faq/ml_faq/negative3.jpg" },
					{ id: 4, text: "prompt_negative_prompt_boy", src: "/faq/ml_faq/negative4.png" },
				],
			},
			{
				id: 11,
				question: dictionary["page_image_generator"]["faq"]["question_11"],
				answer: dictionary["page_image_generator"]["faq"]["answer_11"],
				active: false,
				anchor: "seed",
				images: [
					{ id: 1, text: "boy_red", src: "/faq/ml_faq/seed1.jpg" },
					{ id: 2, text: "boy_blue", src: "/faq/ml_faq/seed2.jpg" },
					{ id: 3, text: "boy_yellow", src: "/faq/ml_faq/seed3.jpg" },
					{ id: 4, text: "boy_beige", src: "/faq/ml_faq/seed4.jpg" },
				],
			},
			{
				id: 12,
				question: dictionary["page_image_generator"]["faq"]["question_12"],
				answer: dictionary["page_image_generator"]["faq"]["answer_12"],
				active: false,
				anchor: "steps",
				images: [
					{ id: 1, text: "prompt_wolf", src: "/faq/ml_faq/steps1.jpg" },
					{ id: 2, text: "prompt_wolf", src: "/faq/ml_faq/steps2.jpg" },
					{ id: 3, text: "prompt_wolf", src: "/faq/ml_faq/steps3.jpg" },
				],
			},
			{
				id: 13,
				question: dictionary["page_image_generator"]["faq"]["question_13"],
				answer: dictionary["page_image_generator"]["faq"]["answer_13"],
				active: false,
				anchor: "sampler",
				images: [
					{ id: 1, text: "k_dpmpp_2m", src: "/faq/ml_faq/sampler1.jpg" },
					{ id: 2, text: "k_dpmpp_2s_a", src: "/faq/ml_faq/sampler2.jpg" },
					{ id: 3, text: "plms", src: "/faq/ml_faq/sampler3.jpg" },
					{ id: 4, text: "ddim", src: "/faq/ml_faq/sampler4.jpg" },
					{ id: 5, text: "k_dpm_fast", src: "/faq/ml_faq/sampler5.jpg" },
					{ id: 6, text: "k_dpm_adaptive", src: "/faq/ml_faq/sampler6.jpg" },
					{ id: 7, text: "k_lms", src: "/faq/ml_faq/sampler7.jpg" },
					{ id: 8, text: "k_dpm_2", src: "/faq/ml_faq/sampler8.jpg" },
					{ id: 9, text: "k_dpm_2_a", src: "/faq/ml_faq/sampler9.jpg" },
					{ id: 10, text: "k_euler", src: "/faq/ml_faq/sampler10.jpg" },
					{ id: 11, text: "k_euler_a", src: "/faq/ml_faq/sampler11.jpg" },
					{ id: 12, text: "k_heun", src: "/faq/ml_faq/sampler12.jpg" },
				],
			},
		],
	};
};

function FaqComponentNew({ pageName }) {
	const { locale } = useRouter();

	const dictionary = getCommonLocales(locale);
	const dictionaryFaq = getFaqLocales(locale);

	const pageObj = dictionary[pageName] ? dictionary[pageName] : { ...getCommonLocales("en") }[pageName];
	const faq = pageObj ? pageObj["faq"] : null;
	let faqSize = faq && Object.keys(faq).length / 2;

	const questionsData = (() => {
		let arr = [];

		if (pageName === "PhotoIntoPainting" || pageName === "TextToImg") {
			arr = dataForGenerators(dictionary)[pageName];
			return arr;
		}

		if (pageName === "page_editor") {
			for (let i = 1; i < faqSize; i++) arr = [...arr, { id: i, question: faq[`question_${i + 1}`], answer: faq[`answer_${i + 1}`] }];
			return arr;
		}

		for (let i = 0; i < faqSize; i++) {
			arr = [...arr, { id: i, question: faq[`question_${i + 1}`], answer: faq[`answer_${i + 1}`] }];
		}
		return arr;
	})();

	const [openQuestions, setOpenQuestion] = useState([]);
	const checkActiveQuestion = (id) => {
		return openQuestions.includes(id);
	};
	const toggleQuestion = (id) => {
		checkActiveQuestion(id) ? setOpenQuestion((prev) => prev.filter((item) => item !== id)) : setOpenQuestion((prev) => [...prev, id]);
	};

	return (
		<section className={`${style.section}`}>
			<h2 className={style.title}>{dictionaryFaq["page title"]}</h2>
			<div className={style.container}>
				{questionsData.map((item) => (
					<div onClick={() => toggleQuestion(item.id)} key={item.id} className={style.item}>
						<div className={`${style.question} ${checkActiveQuestion(item.id) ? style.active : ""}`}>
							<h3>{dictionary["fag"][item.question] || dictionary["faq"][item.question] || dictionary[item.question] || item.question}</h3>
							<HandySvg className={style.arrow} src={"/remove_back/magic_bg/arrow.svg"} width={13} height={9} />
						</div>
						<div className={style.answer}>
							<div>{item.answer}</div>
						</div>
					</div>
				))}
			</div>
		</section>
	);
}

export default FaqComponentNew;
